import LessonProgressDashboardStats from '@/models/LessonProgressDashboardStats';
import { isBlockedLesson } from '@/utils/isBlockedLesson';

export const findNextLessonToDo = (
  lessonProgresses: LessonProgressDashboardStats[],
): LessonProgressDashboardStats | undefined =>
  lessonProgresses.find(
    ({ lesson, presenceStatus }) =>
      lesson.hasDone !== true &&
      !isBlockedLesson({
        datetime: lesson.datetime,
        presence: presenceStatus,
        lessonId: lesson.id,
        hasDone: lesson.hasDone,
      }),
  ) ?? lessonProgresses.at(0);
